import TUG from "./TUGForm";
import MMTForm from "./MMTForm";
import ROMForm from "./ROMForm";
import MASForm from "./MASForm";
import WSTForm from "./WSTForm";
import MFRTForm from "./MFRTForm";
import BergBalanceScale from "./BBS";
import WISCIForm from "./WISCIForm"
import SixMWTForm from "./SixMWTForm";
import SixMWPTForm from "./SixMWPTForm";
import { useState, useEffect } from "react";
import TenMWTForm from "./TenMWTForm";
import CommonFormBuilder from "../../CommonComponenets/FormBuilder";
import PatientCard from "../../../shared/cards/PatientCard";
import { API_URL } from "../../../platform/config/api.config";
import api, { setAccessToken } from "../../../shared/api/apiClient";

const PROGNOSIS_OPTIONS = [
  { label: "Excellent", value: "excellent" },
  { label: "Good", value: "good" },
  { label: "Fair", value: "fair" },
  { label: "Poor", value: "poor" }
];

const SPINAL_CONTAINER_SCHEMA = {
  title: "Patient Information",
  sections: []
};

const CONSENT_AND_REFERRAL_SCHEMA = {
  title: "",
  sections: [
    {
      fields: [
        {
          type: "row",
          fields: [
            {
              name: "consent_obtained",
              type: "checkbox-group",
              options: [{ label: "Consent obtained", value: "yes" }]
            },
            {
              name: "consent_upload",
              label: "Upload",
              type: "file-upload",
              showIf: { field: "consent_obtained", includes: "yes" }
            }
          ]
        },
        {
          name: "hep_reviewed",
          type: "checkbox-group",
          options: [{ label: "Home Exercise Program (HEP) reviewed and demonstrated", value: "yes" }]
        },
        {
          name: "current_diagnosis",
          label: "Current Diagnosis",
          type: "multi-select-dropdown",
          options: [
            { label: "Stroke", value: "stroke" },
            { label: "Traumatic Brain Injury", value: "tbi" },
            { label: "Parkinson Disease", value: "parkinson" },
            { label: "Spinal Cord Injury", value: "sci" },
            { label: "Peripheral Neuropathy", value: "peripheral_neuropathy" },
            { label: "Ligament injuries", value: "ligament_injuries" },
            { label: "Ataxia", value: "ataxia" },
            { label: "Others", value: "others" }
          ]
        },
        {
          name: "current_diagnosis_other",
          label: "Other Diagnosis (specify)",
          type: "input",
          showIf: { field: "current_diagnosis", includes: "others" }
        },
        {
          name: "equipment_owned",
          label: "List of Equipment Owned",
          type: "checkbox-group",
          options: [
            { label: "PERKESO", value: "perkeso" },
            { label: "NGO", value: "ngo" },
            { label: "Self-purchased", value: "self" },
            { label: "Others", value: "others" }
          ]
        },
        {
          name: "equipment_perkeso",
          label: "PERKESO Equipment Details",
          type: "input",
          showIf: { field: "equipment_owned", includes: "perkeso" }
        },
        {
          name: "equipment_ngo",
          label: "NGO Equipment Details",
          type: "input",
          showIf: { field: "equipment_owned", includes: "ngo" }
        },
        {
          name: "equipment_self",
          label: "Self-purchased Equipment Details",
          type: "input",
          showIf: { field: "equipment_owned", includes: "self" }
        },
        {
          name: "equipment_others",
          label: "Other Equipment Details",
          type: "input",
          showIf: { field: "equipment_owned", includes: "others" }
        }
        ,
        { type: "subheading", label: "Referral Information" },
        {
          name: "referred_by",
          label: "Referred by",
          type: "input",
          readOnly: true
        },
        {
          name: "referral_reasons",
          label: "Referral Reasons",
          type: "input",
          readOnly: true
        }
      ]
    }
  ]
};

const SUBJECTIVE_SCHEMA = {
    actions: [
      { type: "back", label: "Back" },
      { type: "clear", label: "Clear" },
      { type: "save", label: "Save" }
    ],
    fields: [
      {
        name: "chief_complaint",
        label: "Chief Complaint",
        type: "input"
      },
      {
        name: "hopi",
        label: "History of Presenting Illness",
        type: "input"
      },
      {
        name: "pain_score",
        label: "Pain Score(Visual Analog Scale)",
        type: "scale-slider",

        min: 0,
        max: 10,
        ranges: [
          {
            min: 0,
            max: 1,
            label: "Mild",
            color: "#22c55e"   // green
          },
          {
            min: 1,
            max: 5,
            label: "Moderate",
            color: "#facc15"   // yellow
          },
          {
            min: 5,
            max: 10,
            label: "Severe",
            color: "#ef4444"   // red
          }
        ],
        showValue: true
      },
      {
        name: "medication",
        label: "Current Medication",
        type: "input"
      },
      {
        name: "social_history",
        label: "Social History",
        type: "subheading"
      },
      {
        name: "house_type",
        label: "Type of House",
        type: "radio",
        options: [
          { label: "Single storey", value: "single" },
          { label: "Double storey", value: "double" },
          { label: "Apartment with lift", value: "apartment" },
          { label: "Others", value: "others" }
        ]
      },
      {
        name: "house_type_other",
        label: "Specify",
        type: "input",
        showIf: { field: "house_type", equals: "others" }
      },
      {
        name: "toilet_type",
        label: "Toilet type",
        type: "radio",
        options: [
          { label: "Sitting", value: "sitting" },
          { label: "Squatting", value: "squatting" }
        ]
      },
      {
        name: "marital_status",
        label: "Marital Status",
        type: "radio",
        options: [
          { label: "Single", value: "single" },
          { label: "Married", value: "married" },
          { label: "Divorced", value: "divorced" }
        ]
      },
      {
        name: "care_giver",
        label: "Caregiver",
        type: "radio",
        options: [
          { label: "Live Alone", value: "live_alone" },
          { label: "Lives With Family", value: "live_with_family" }
        ]
      },
      {
        name: "employement_status",
        label: "Employement Status",
        type: "radio",
        options: [
          { label: "Employed", value: "employed" },
          { label: "Unemployed", value: "unemployed" }
        ]
      },
      // {
      //   name: "patient_goals",
      //   label: "Patient Goals",
      //   type: "subheading"
      // },
      // {
      //   name: "short_term_goals",
      //   label: "Short Term Goals",
      //   type: "input"
      // },
      // {
      //   name: "long_term_goals",
      //   label: "Long Term Goals",
      //   type: "input"
      // },
      // {
      //   name: "bowel",
      //   label: "Bowel",
      //   type: "radio",
      //   options: [
      //     { label: "Continence", value: "continence" },
      //     { label: "Incontinence", value: "incontinence" }
      //   ]
      // },
      // {
      //   name: "bladder",
      //   label: "Bladder",
      //   type: "radio",
      //   options: [
      //     { label: "Continence", value: "continence" },
      //     { label: "Incontinence", value: "incontinence" }
      //   ]
      // },
       {
        name: "Patient-Reported Functional Goals",
        label: "Patient Reported Functional Goals",
        type: "input"
      },
      {
        name: "bowel_control",
        label: "Bowel control",
        type: "radio",
        options: [
          { label: "Continence", value: "continence" },
          { label: "Incontinence", value: "incontinence" }
        ]
      },
      {
  name: "bowel_control_details",
  label: "Bowel Incontinence Details",
  type: "input",
  placeholder: "Enter bowel incontinence details",
  showIf: {
    field: "bowel_control",
    equals: "incontinence"
  }
},
      {
        name: "bladder",
        label: "Bladder control",
        type: "radio",
        options: [
          { label: "Continence", value: "continence" },
          { label: "Incontinence", value: "incontinence" }
        ]
      },
      {
  name: "bladder_details",
  label: "Bladder Incontinence Details",
  type: "input",
  placeholder: "Enter bladder incontinence details",
  showIf: {
    field: "bladder",
    equals: "incontinence"
  }
},
    ]
}

const OBJECTIVE_SCHEMA = {
  
  actions: SUBJECTIVE_SCHEMA.actions,
  sections: [
    {
      fields: [
        { type: "subheading", label: "General Observation" },
        {
          name: "body_size",
          label: "Body Size",
          type: "radio",
          options: [
            { label: "Ectomorph",  value: "ectomorph"  },
            { label: "Mesomorph",  value: "mesomorph"  },
            { label: "Endomorph",  value: "endomorph"  },
          ],
        },
        {
          name: "ambulation",
          label: "Ambulation",
          type: "radio",
          options: [
            { label: "Wheelchair (self propel)",      value: "wheelchair_self"   },
            { label: "Wheelchair (motorized)",        value: "wheelchair_motor"  },
            { label: "Wheelchair (assist by carer)",  value: "wheelchair_carer"  },
            { label: "Walking aids",                  value: "walking_aids"      },
            { label: "Walk independently",                value: "independent"       },
          ],
        },
        {
          name: "walking_aids_type",
          label: "Walking Aids (specify)",
          type: "input",
          placeholder: "e.g. elbow crutches, walking frame...",
          showIf: { field: "ambulation", equals: "walking_aids" },
        },
        {
          name: "accompanied_by",
          label: "Accompanied By",
          type: "radio",
          options: [
            { label: "With carer",    value: "with_carer"    },
            { label: "Without carer", value: "without_carer" },
          ],
        },
        {
          name: "generated_observation_display",
          label: "Generated Observation",
          type: "input",
          readOnly: true,
          showIf: { field: "generated_observation_display", notEmpty: true },
        },
        {
          name: "local_observations",
          label: "Local Observations",
          type: "input"
        },
        {
          name: "palpation",
          label: "Palpation",
          type: "input"
        },
        {
          type: "subheading",
          label: "Scales / Outcome Measures"
        },
        {
          name: "spinal_scales_launcher",
          type: "assessment-launcher",
          options: [
            { label: "Range of Motion (ROM)", value: "rom" },
            { label: "Manual Muscle Test (MMT)", value: "mmt" },
            { label: "Muscle Tone (MAS)", value: "mas" },
            { label: "10 Meter Walk Test", value: "tenmwt" },
            { label: "Berg Balance Scale (BBS)", value: "bbs" },
            { label: "Timed Up and Go (TUG)", value: "tug" },
            { label: "6 Minutes Walk Test (6MWT)", value: "sixmwt" },
            { label: "6 Minutes Wheelchair Pust Test", value: "sixmwpt"},
            { label: "Wheelchair Skills Test", value: "wst"},
            { label: "Walking Index for Spinal Cord Injury", value: "wisci"},
            { label: "Modified Functional Reach Test", value: "mfrt"}
          ]
        },
          {
          name: "spinal_scales",
          type: "multi-select-dropdown",
          label: "Select Outcome Measures",
          options: [
            { label: "Range of Motion (ROM)",                    value: "rom"     },
            { label: "Manual Muscle Test (MMT)",                 value: "mmt"     },
            { label: "Muscle Tone (MAS)",                        value: "mas"     },
            { label: "10 Meter Walk Test",                       value: "tenmwt"  },
            { label: "Berg Balance Scale (BBS)",                 value: "bbs"     },
            { label: "Timed Up and Go (TUG)",                    value: "tug"     },
            { label: "6 Minutes Walk Test (6MWT)",               value: "sixmwt"  },
            { label: "6 Minutes Wheelchair Push Test",           value: "sixmwpt" },
            { label: "Wheelchair Skills Test",                   value: "wst"     },
            { label: "Walking Index for Spinal Cord Injury",     value: "wisci"   },
            { label: "Modified Functional Reach Test",           value: "mfrt"    },
          ]
        },
        /* Free-text parameter field for each selected scale */
        { name: "rom_params",     label: "ROM — Parameters / Notes",                        type: "input", showIf: { field: "spinal_scales", includes: "rom"     } },
        { name: "mmt_params",     label: "MMT — Parameters / Notes",                        type: "input", showIf: { field: "spinal_scales", includes: "mmt"     } },
        { name: "mas_params",     label: "MAS — Parameters / Notes",                        type: "input", showIf: { field: "spinal_scales", includes: "mas"     } },
        { name: "tenmwt_params",  label: "10 Meter Walk Test — Parameters / Notes",         type: "input", showIf: { field: "spinal_scales", includes: "tenmwt"  } },
        { name: "bbs_params",     label: "Berg Balance Scale — Parameters / Notes",         type: "input", showIf: { field: "spinal_scales", includes: "bbs"     } },
        { name: "tug_params",     label: "TUG — Parameters / Notes",                        type: "input", showIf: { field: "spinal_scales", includes: "tug"     } },
        { name: "sixmwt_params",  label: "6MWT — Parameters / Notes",                       type: "input", showIf: { field: "spinal_scales", includes: "sixmwt"  } },
        { name: "sixmwpt_params", label: "6 Min Wheelchair Push Test — Parameters / Notes", type: "input", showIf: { field: "spinal_scales", includes: "sixmwpt" } },
        { name: "wst_params",     label: "Wheelchair Skills Test — Parameters / Notes",     type: "input", showIf: { field: "spinal_scales", includes: "wst"     } },
        { name: "wisci_params",   label: "WISCI — Parameters / Notes",                      type: "input", showIf: { field: "spinal_scales", includes: "wisci"   } },
        { name: "mfrt_params",    label: "MFRT — Parameters / Notes",                       type: "input", showIf: { field: "spinal_scales", includes: "mfrt"    } },

      ]
    }
  ]
};

const ASSESSMENT_SCHEMA = {

  actions: SUBJECTIVE_SCHEMA.actions,
  sections: [
    {
      fields: [
               {
  type: "subheading",
  label: "Problem List"
},
            {
  name: "problem_list",
  type: "checkbox-group",
  options: [
    { label: "Reduced muscle strength", value: "reduced_muscle_strength" },
    { label: "Reduced muscle endurance", value: "reduced_muscle_endurance" },
    { label: "Reduced cardiovascular endurance", value: "reduced_cardiovascular_endurance" },
    { label: "Reduced ROM", value: "reduced_rom" },
    { label: "Poor wheelchair skills", value: "poor_wheelchair_skills" },
    { label: "Reduced standing balance", value: "reduced_standing_balance" },
    { label: "Reduced sitting balance", value: "reduced_sitting_balance" },
    { label: "Poor trunk control", value: "poor_trunk_control" },
    { label: "Unable to walk", value: "unable_to_walk" },
    { label: "Poor walking endurance", value: "poor_walking_endurance" },
    { label: "Poor wheelchair endurance", value: "poor_wheelchair_endurance" },
    { label: "Others", value: "other" }
  ]
},
{
  name: "problem_list_other_text",
  label: "Other Problem (Specify)",
  type: "input",
  placeholder: "Enter additional problems...",
  showIf: {
    field: "problem_list",
    includes: "other"
  }
},
//              {
//   type: "subheading",
//   label: "Functional Limitations"
// },

//       {name:"functional_limitations", type:"checkbox-group",
//         options: [
//     { label: "Gait Impairment", value: "gaitimpairment" },
//     { label: "Unsafe Transfers", value: "unsafetransfers" },
//     { label: "Reduced Endurance", value: "reducedendurance" },
//     { label: "Balance Deficit", value: "balancedeficit" },
//     { label: "ADL Dependency", value: "adldependency" },
//     { label: "No Functional Limitations", value: "nofunctionallimitations" },
//     { label: "Others", value: "others" }
//   ]
//       },
//       {
//           name: "functional_limitations_others",
//           label: "Specify Others",
//           type: "input",
//           showIf: { field: "functional_limitations", includes: "others" }
//         },
      {
        name: "clinical_impression",
        label: "Clinical Impression",
        type: "input"
      },
      {
        name: "prognosis",
        label: "Rehab Prognosis",
        type: "radio",
        options: PROGNOSIS_OPTIONS
      },
      ]
    }
  ]
};

const PLAN_SCHEMA = {
  title: "",
  actions: SUBJECTIVE_SCHEMA.actions,
  sections: [
    {
      fields: [
          { type: "subheading", label: "Short-Term Goals (2–4 weeks)" },
          {
            type: "dynamic-goals",
            name: "short_term_goals"
          },
          { type: "subheading", label: "Long-Term Goals (6–12 weeks)" },
          {
            type: "dynamic-goals",
            name: "long_term_goals"
          }, 
           { type: "subheading", label: "Interventions and Plan" }, 
            {
  name: "equipment_list",
  label: "Equipment List",
  type: "equipment-list",
  options: []
},
             { type: "subheading", label: "Treatment Plan" },
        {
  name: "intervention_plan",
  type: "checkbox-group",
  options: [
    { label: "Stretching", value: "stretching" },
    { label: "Strengthening", value: "strengthening" },
    { label: "Sitting Balance Training", value: "sitting_balance_training" },
    { label: "Standing Balance Training", value: "standing_balance_training" },
    { label: "Endurance Training", value: "endurance_training" },
    { label: "Gait Training", value: "gait_training" },
    { label: "Transfer Training", value: "transfer_training" },
    { label: "Wheelchair Skills Training", value: "wheelchair_skills_training" },
    { label: "Walking Aids Prescription", value: "walking_aids_prescription" }
  ]
},

// Stretching
{
  name: "stretching_frequency",
  label: "Stretching - Frequency",
  type: "input",
  placeholder: "e.g. 3 times per week",
  showIf: {
    field: "intervention_plan",
    includes: "stretching"
  }
},
{
  name: "stretching_duration",
  label: "Stretching - Duration",
  type: "input",
  placeholder: "e.g. 6 weeks",
  showIf: {
    field: "intervention_plan",
    includes: "stretching"
  }
},

// Strengthening
{
  name: "strengthening_frequency",
  label: "Strengthening - Frequency",
  type: "input",
  placeholder: "e.g. 3 times per week",
  showIf: {
    field: "intervention_plan",
    includes: "strengthening"
  }
},
{
  name: "strengthening_duration",
  label: "Strengthening - Duration",
  type: "input",
  placeholder: "e.g. 6 weeks",
  showIf: {
    field: "intervention_plan",
    includes: "strengthening"
  }
},

// Sitting Balance Training
{
  name: "sitting_balance_training_frequency",
  label: "Sitting Balance Training - Frequency",
  type: "input",
  placeholder: "e.g. 3 times per week",
  showIf: {
    field: "intervention_plan",
    includes: "sitting_balance_training"
  }
},
{
  name: "sitting_balance_training_duration",
  label: "Sitting Balance Training - Duration",
  type: "input",
  placeholder: "e.g. 6 weeks",
  showIf: {
    field: "intervention_plan",
    includes: "sitting_balance_training"
  }
},

// Standing Balance Training
{
  name: "standing_balance_training_frequency",
  label: "Standing Balance Training - Frequency",
  type: "input",
  placeholder: "e.g. 3 times per week",
  showIf: {
    field: "intervention_plan",
    includes: "standing_balance_training"
  }
},
{
  name: "standing_balance_training_duration",
  label: "Standing Balance Training - Duration",
  type: "input",
  placeholder: "e.g. 6 weeks",
  showIf: {
    field: "intervention_plan",
    includes: "standing_balance_training"
  }
},

// Endurance Training
{
  name: "endurance_training_frequency",
  label: "Endurance Training - Frequency",
  type: "input",
  placeholder: "e.g. 3 times per week",
  showIf: {
    field: "intervention_plan",
    includes: "endurance_training"
  }
},
{
  name: "endurance_training_duration",
  label: "Endurance Training - Duration",
  type: "input",
  placeholder: "e.g. 6 weeks",
  showIf: {
    field: "intervention_plan",
    includes: "endurance_training"
  }
},

// Gait Training
{
  name: "gait_training_frequency",
  label: "Gait Training - Frequency",
  type: "input",
  placeholder: "e.g. 3 times per week",
  showIf: {
    field: "intervention_plan",
    includes: "gait_training"
  }
},
{
  name: "gait_training_duration",
  label: "Gait Training - Duration",
  type: "input",
  placeholder: "e.g. 6 weeks",
  showIf: {
    field: "intervention_plan",
    includes: "gait_training"
  }
},

// Transfer Training
{
  name: "transfer_training_frequency",
  label: "Transfer Training - Frequency",
  type: "input",
  placeholder: "e.g. 3 times per week",
  showIf: {
    field: "intervention_plan",
    includes: "transfer_training"
  }
},
{
  name: "transfer_training_duration",
  label: "Transfer Training - Duration",
  type: "input",
  placeholder: "e.g. 6 weeks",
  showIf: {
    field: "intervention_plan",
    includes: "transfer_training"
  }
},

// Wheelchair Skills Training
{
  name: "wheelchair_skills_training_frequency",
  label: "Wheelchair Skills Training - Frequency",
  type: "input",
  placeholder: "e.g. 3 times per week",
  showIf: {
    field: "intervention_plan",
    includes: "wheelchair_skills_training"
  }
},
{
  name: "wheelchair_skills_training_duration",
  label: "Wheelchair Skills Training - Duration",
  type: "input",
  placeholder: "e.g. 6 weeks",
  showIf: {
    field: "intervention_plan",
    includes: "wheelchair_skills_training"
  }
},

// Walking Aids Prescription
{
  name: "walking_aids_prescription_frequency",
  label: "Walking Aids Prescription - Frequency",
  type: "input",
  placeholder: "e.g. Once during treatment",
  showIf: {
    field: "intervention_plan",
    includes: "walking_aids_prescription"
  }
},
{
  name: "walking_aids_prescription_duration",
  label: "Walking Aids Prescription - Duration",
  type: "input",
  placeholder: "e.g. 1 session",
  showIf: {
    field: "intervention_plan",
    includes: "walking_aids_prescription"
  }
},     
 { type: "subheading", label: "Interventions Plan" },       
{
  name: "interventions_plan",
  type: "checkbox-group",
  options: [
    { label: "Bed mobility training", value: "bed_mobility_training" },
    { label: "Transfer training", value: "transfer_training" },
    { label: "Muscle tone management", value: "muscle_tone_management" },
    { label: "Sitting balance training", value: "sitting_balance_training" },
    { label: "Standing balance training", value: "standing_balance_training" },
    { label: "Functional ROM exercise", value: "functional_rom_exercise" },
    { label: "Functional strengthening exercise", value: "functional_strengthening_exercise" },
    { label: "Endurance training", value: "endurance_training" },
    { label: "Functional training", value: "functional_training" },
    { label: "Gait training", value: "gait_training" },
    { label: "Bobath / NDT therapy", value: "bobath_ndt_therapy" },
    { label: "Walking aid prescription", value: "walking_aid_prescription" },
    { label: "Others", value: "other" }
  ]
},
{
  name: "interventions_plan_other",
  label: "Specify Other Intervention",
  type: "input",
  placeholder: "Enter other rehabilitation intervention",
  showIf: {
    field: "interventions_plan",
    includes: "other"
  }
},
        // {
        //   name: "home_exercise-program",
        //   label: "Home Exercise Program",
        //   type: "input"
        // },
        { type: "subheading", label: "HEP (home exercise program)" },
        {
  name: "hep_home_exercise_program",
  type: "checkbox-group",
  options: [
    { label: "Strengthening exercises", value: "strengthening_exercises" },
    { label: "Stretching exercises", value: "stretching_exercises" },
    { label: "Standing / sitting balance training", value: "balance_training" },
    { label: "Endurance training", value: "endurance_training" },
    { label: "Fitness regime", value: "fitness_regime" },
    { label: "Mobilization", value: "mobilization" },
    { label: "ROM exercise", value: "rom_exercise" },
    { label: "Patient & carer education", value: "patient_carer_education" },
    { label: "Others", value: "other" }
  ]
},
   { type: "subheading", label: " Follow-up plans" },     
{
  name: "follow_up_plan",
  type: "checkbox-group",
  options: [
    {
      label: "Reassessment scheduled in 2–4 weeks",
      value: "reassessment_2_4_weeks"
    },
    {
      label: "Track progress via outcome measures",
      value: "track_progress_outcome_measures"
    }
  ]
},
// { 
//           name: "referrals", 
//           label: "Referrals", 
//           type: "checkbox-group",
//           options: [
//             { label: "Neuro-Robotic ", value: "neuro_robotic" },
//             { label: "Hydrotherapy ", value: "hydrotherapy" },
//             { label: "Pain Management", value: "pain_management" },
//           ]
//         },
//         {
//           name: "remarks",
//           label: "Remarks",
//           type: "input"
//         }
      ]
    }
  ]
};

const schemaMap = {
    subjective: SUBJECTIVE_SCHEMA,
    objective: OBJECTIVE_SCHEMA,
    assessment: ASSESSMENT_SCHEMA,
    plan: PLAN_SCHEMA
};

const SPINAL_ASSESSMENT_REGISTRY = {
  tug: TUG,
  rom: ROMForm,
  mmt: MMTForm,
  mas: MASForm,
  wst: WSTForm,
  mfrt: MFRTForm,
  wisci: WISCIForm,
  tenmwt: TenMWTForm,
  sixmwt: SixMWTForm,
  sixmwpt: SixMWPTForm,
  bbs: BergBalanceScale,
};


export default function SpinalCordInjury({patient, onSubmit, onBack}) {
  const [values, setValues] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [activeTab, setActiveTab] = useState("subjective");
  const [equipmentOptions, setEquipmentOptions] = useState([]);
  const [equipmentBookingOpen, setEquipmentBookingOpen] = useState(false);
  const [selectedEquipment, setSelectedEquipment] = useState(null);
  const [bookedEquipmentIds, setBookedEquipmentIds] = useState([]);
  
  /* ---------------- STORAGE ---------------- */
  const storageKey = patient
    ? `spinal_assessment_draft_${patient.id}`
    : null;

useEffect(() => {
  const fetchEquipmentList = async () => {
    try {
      const response = await api.get(API_URL.EQUIPMENT_LIST);

      const result = response.data;

const options =
  result?.data?.map(item => ({
    label: item.equipment_name,
    value: item.id,
    status: item.status,
    equipment_code: item.equipment_code,
    department_name: item.department_name,
    raw: item,
  })) || [];

setEquipmentOptions(options);
    } catch (error) {
      console.error("Equipment list fetch failed:", error);
    }
  };

  fetchEquipmentList();
}, []);    
   
  useEffect(() => {
    if (!storageKey) return;
    const saved = localStorage.getItem(storageKey);
    if (saved) {
      setValues(JSON.parse(saved).values || {});
    }
  }, [storageKey]);
   useEffect(() => {
          if (!storageKey) return;
          const saved = localStorage.getItem(storageKey);
          if (saved) {
            try {
              setValues(JSON.parse(saved).values || {});
            } catch {}
          }
        }, [storageKey]);


  useEffect(() => {
    if (!patient) return;
    setValues(v => ({
      ...v,
      pmh_from_registration:
        patient.medical_history || "No data available",
  
      family_social_from_registration:
        patient.diagnosis_history || "No data available",
      referred_by: patient.case_manager || "",
      referral_reasons: patient.diagnosis_history || patient.icd || ""
    }));
  }, [patient]);

  const onChange = (name, value) => {
    setValues(v => {
      const updated = { ...v, [name]: value };

      // Auto-generate the observation sentence when relevant fields change
      if (["body_size","ambulation","walking_aids_type","accompanied_by"].includes(name)) {
        const bs = name === "body_size"       ? value : updated.body_size;
        const am = name === "ambulation"      ? value : updated.ambulation;
        const wt = name === "walking_aids_type" ? value : updated.walking_aids_type;
        const ac = name === "accompanied_by"  ? value : updated.accompanied_by;

        const bodySize = bs ? bs.charAt(0).toUpperCase() + bs.slice(1) : null;

        let ambulation = null;
        if (am === "wheelchair_self")   ambulation = "via wheelchair (self propel)";
        else if (am === "wheelchair_motor") ambulation = "via wheelchair (motorized)";
        else if (am === "wheelchair_carer") ambulation = "via wheelchair (assisted by carer)";
        else if (am === "walking_aids")     ambulation = `via walking aids${wt ? ` (${wt})` : ""}`;
        else if (am === "independent")      ambulation = "walking independently";

        const accompanied = ac === "with_carer" ? "carer" : ac === "without_carer" ? "without carer" : null;

        if (bodySize && ambulation && accompanied) {
          updated.generated_observation_display =
            `Patient with ${bodySize} body size came into SCI Unit ${ambulation} accompanied by ${accompanied}.`;
        } else {
          updated.generated_observation_display = "";
        }
      }

      return updated;
    });
  };

  const handleAction = (type) => {
    if (type === "back") onBack?.();
    if (type === "clear") {
      setValues({});
      setSubmitted(false);
      localStorage.removeItem(storageKey);
    }
    if (type === "save") {
      localStorage.setItem(
        storageKey,
        JSON.stringify({ values, updatedAt: new Date() })
      );
      alert("Spinal draft saved");
    }
  };
 
  const handleSubmit = () => {
    setSubmitted(true);
    onSubmit?.(values);
    alert("Spinal assessment submitted");
  };

  const handleEquipmentBook = (equipment) => {
    setSelectedEquipment(equipment);
    setEquipmentBookingOpen(true);
  };

const planSchema = {
  ...PLAN_SCHEMA,
  sections: PLAN_SCHEMA.sections.map((section) => ({
    ...section,
    fields: section.fields.map((field) =>
      field.name === "equipment_list"
        ? { ...field, options: equipmentOptions, onBook: handleEquipmentBook, bookedEquipmentIds }
        : field
    ),
  })),
};

  return (
    <div style={mainContent}>
    
         <PatientCard
                  patient={patient}
                  
                />
              
                
      {/* ===== CONSENT & REFERRAL ===== */}
      <CommonFormBuilder
        schema={CONSENT_AND_REFERRAL_SCHEMA}
        values={values}
        onChange={onChange}
      />
      {/* ===== TABS ===== */}
      <div style={tabBar}>
        {["subjective", "objective", "assessment", "plan"].map(tab => (
          <div
            key={tab}
            style={activeTab === tab ? tabActive : tabBtn}
            onClick={() => setActiveTab(tab)}
          >
            {tab.toUpperCase()}
          </div>
        ))}
      </div>

      {/* ===== TAB CONTENT ===== */}
      <CommonFormBuilder
        schema={
          activeTab === "plan"
            ? planSchema
            : schemaMap[activeTab]
        }
        values={values}
        onChange={onChange}
        submitted={submitted}
        onAction={handleAction}
        assessmentRegistry={SPINAL_ASSESSMENT_REGISTRY}
      >
        {/* Generated Observation — shown inside the card on Objective tab, only when all 3 fields selected */}
        {/* {activeTab === "objective" && values.body_size && values.ambulation && values.accompanied_by && (
          <GeneratedObservationBanner values={values} />
        )} */}

        <div style={submitRow}>
          {activeTab !== "plan" ? (
            <button
              type="button"
              style={submitBtn}
              onClick={() => {
                if (activeTab === "subjective") setActiveTab("objective");
                else if (activeTab === "objective") setActiveTab("assessment");
                else if (activeTab === "assessment") setActiveTab("plan");
              }}
            >
              Next
            </button>
          ) : (
            <button
              type="button"
              style={submitBtn}
              onClick={handleSubmit}
            >
              Submit Spinal Cord Assessment
            </button>
          )}
        </div>
      </CommonFormBuilder>
      <EquipmentBookingPopup
        open={equipmentBookingOpen}
        equipmentOptions={equipmentOptions}
        selectedEquipment={selectedEquipment}
        onClose={() => setEquipmentBookingOpen(false)}
        onBooked={(equipmentId) => {
          setBookedEquipmentIds(prev => [...prev, equipmentId]);
        }}
      />
    </div>
  );
}


/* ── Generated Observation Banner ── */
function EquipmentBookingPopup({
  open,
  equipmentOptions,
  selectedEquipment,
  onClose,
  onBooked
}) {
  const [equipmentId, setEquipmentId] = useState("");

  useEffect(() => {
    if (open) {
      setEquipmentId(selectedEquipment?.value || "");
    }
  }, [open, selectedEquipment]);

  if (!open) return null;

  const currentEquipment =
    equipmentOptions.find(item => String(item.value) === String(equipmentId)) ||
    selectedEquipment ||
    {};

  const departmentOptions = Array.from(
    new Set(equipmentOptions.map(item => item.department_name).filter(Boolean))
  );

  const selectedDepartment = currentEquipment.department_name || "";

  return (
    <div style={equipmentModalOverlay}>
      <div style={equipmentModal}>
        <div style={equipmentModalHeader}>
          <div>
            <div style={equipmentModalTitle}>Create Equipment Booking</div>
            <div style={equipmentModalSubtitle}>
              Reserve equipment for internal use. Fields marked with * are required.
            </div>
          </div>
          <button type="button" style={equipmentCloseBtn} onClick={onClose}>×</button>
        </div>

        <div style={equipmentModalBody}>
          <div style={equipmentSectionTitle}>Basic Details</div>
          <div style={equipmentGrid}>
            <EquipmentPopupField label="Equipment *">
              <select
                style={equipmentInput}
                value={equipmentId}
                onChange={(event) => setEquipmentId(event.target.value)}
              >
                <option value="">Select equipment</option>
                {equipmentOptions.map(item => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </EquipmentPopupField>

            <EquipmentPopupField label="Booking Date *">
              <input type="date" style={equipmentInput} />
            </EquipmentPopupField>

            <EquipmentPopupField label="Start Time *">
              <input type="time" style={equipmentInput} />
            </EquipmentPopupField>

            <EquipmentPopupField label="End Time *">
              <input type="time" style={equipmentInput} />
            </EquipmentPopupField>
          </div>

          <div style={equipmentSectionTitle}>Usage Context</div>
          <div style={equipmentGrid}>
            <EquipmentPopupField label="Department *">
              <select style={equipmentInput} value={selectedDepartment} disabled>
                <option value="">Select department</option>
                {departmentOptions.map(department => (
                  <option key={department} value={department}>
                    {department}
                  </option>
                ))}
              </select>
            </EquipmentPopupField>

            <EquipmentPopupField label="Appointment Reference *">
              <input
                type="text"
                style={equipmentInput}
                placeholder="Enter appointment reference id"
              />
            </EquipmentPopupField>

            <EquipmentPopupField label="Assigned Staff *">
              <select style={equipmentInput}>
                <option value="">Select staff</option>
              </select>
            </EquipmentPopupField>
          </div>

          <div style={equipmentSectionTitle}>Note</div>
          <EquipmentPopupField label="Purpose of Booking *">
            <textarea
              style={equipmentTextarea}
              placeholder="Describe purpose of booking..."
            />
          </EquipmentPopupField>

          <EquipmentPopupField label="Special Handling Instructions *">
            <textarea
              style={equipmentTextarea}
              placeholder="Describe special handling instructions..."
            />
          </EquipmentPopupField>
        </div>

        <div style={equipmentModalFooter}>
          <button type="button" style={equipmentCancelBtn} onClick={onClose}>
            × Cancel
          </button>
          <button
          type="button"
          style={equipmentBookBtn}
          onClick={() => {
            alert("Equipment booked");
            onBooked?.(equipmentId);
            onClose();
          }}
        >
          Book Equipment
        </button>
        </div>
      </div>
    </div>
  );
}

function EquipmentPopupField({ label, children }) {
  return (
    <label style={equipmentField}>
      <span style={equipmentLabel}>{label}</span>
      {children}
    </label>
  );
}

function GeneratedObservationBanner({ values }) {
  const bodySize = values.body_size
    ? values.body_size.charAt(0).toUpperCase() + values.body_size.slice(1)
    : null;

  let ambulation = null;
  if (values.ambulation === "wheelchair_self")   ambulation = "via wheelchair (self propel)";
  else if (values.ambulation === "wheelchair_motor") ambulation = "via wheelchair (motorized)";
  else if (values.ambulation === "wheelchair_carer") ambulation = "via wheelchair (assisted by carer)";
  else if (values.ambulation === "walking_aids")
    ambulation = `via walking aids${values.walking_aids_type ? ` (${values.walking_aids_type})` : ""}`;
  else if (values.ambulation === "independent")  ambulation = "walking independently";

  const accompanied = values.accompanied_by === "with_carer"
    ? "carer"
    : values.accompanied_by === "without_carer"
    ? "without carer"
    : null;

  if (!bodySize || !ambulation || !accompanied) return null;

  const Tag = ({ children }) => (
    <strong style={{ color: "#1d4ed8", background: "#dbeafe", borderRadius: 4, padding: "1px 6px", fontStyle: "italic" }}>
      {children}
    </strong>
  );

  return (
    <div style={{
      margin: "8px 0 16px",
      padding: "14px 18px",
      background: "#f0f9ff",
      border: "1px solid #bae6fd",
      borderRadius: 10,
      fontSize: 14,
      lineHeight: 2,
      color: "#0c4a6e",
    }}>
      <div style={{ fontWeight: 700, fontSize: 13, color: "#0369a1", marginBottom: 8 }}>
        Generated Observation
      </div>
      <div style={{ fontSize: 14, color: "#1e3a5f", lineHeight: 1.8 }}>
        Patient with <Tag>{bodySize}</Tag> body size came into SCI Unit{" "}
        <Tag>{ambulation}</Tag> accompanied by <Tag>{accompanied}</Tag>.
      </div>
    </div>
  );
}

const mainContent = { margin: "0 auto" };
 
const tabBar = {
  display: "flex",
  gap: 12,
  justifyContent: "center",
  borderBottom: "1px solid #ddd",
  marginBottom: 12
};
const section = {
  marginBottom: 24
};
 
const sectionTitle = {
  fontSize: 16,
  fontWeight: 700,
  marginBottom: 12,
  borderBottom: "1px solid #e5e7eb",
  paddingBottom: 6,
  color: "#0F172A"
};
 
const patientGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
  gap: 12,
  fontSize: 14
};
 
const tabBtn = {
  padding: "10px 22px",
  fontWeight: 600,
  cursor: "pointer",
  color: "#0f172a"
};
 
const tabActive = {
  ...tabBtn,
  borderBottom: "3px solid #2451b3",
  color: "#2451b3"
};
 
const submitRow = {
  display: "flex",
  justifyContent: "flex-end",
  marginTop: 20
};
 
const submitBtn = {
  padding: "12px 32px",
  background: "#2563EB",
  color: "#fff",
  border: "none",
  borderRadius: 10,
  fontSize: 15,
  fontWeight: 700
};

const equipmentModalOverlay = {
  position: "fixed",
  inset: 0,
  zIndex: 10000,
  background: "rgba(0,0,0,0.45)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 16
};

const equipmentModal = {
  width: "min(660px, 100%)",
  maxHeight: "98vh",
  overflow: "hidden",
  background: "#fff",
  borderRadius: 10,
  boxShadow: "0 24px 70px rgba(15,23,42,0.25)",
  display: "flex",
  flexDirection: "column"
};

const equipmentModalHeader = {
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: 16,
  padding: "18px 22px 14px",
  borderBottom: "1px solid #e5e7eb"
};

const equipmentModalTitle = {
  fontSize: 16,
  fontWeight: 800,
  color: "#24272d",
  lineHeight: 1.2
};

const equipmentModalSubtitle = {
  marginTop: 6,
  fontSize: 14,
  color: "#7a7f88"
};

const equipmentCloseBtn = {
  width: 40,
  height: 40,
  borderRadius: 10,
  border: "1px solid #d7dde7",
  background: "#fff",
  color: "#1f2937",
  fontSize: 24,
  lineHeight: "36px",
  cursor: "pointer"
};

const equipmentModalBody = {
  margin: "5px 14px 0",
  padding: "12px 16px 18px",
  border: "1px solid #dce2ea",
  borderRadius: 12,
  overflowY: "auto"
};

const equipmentSectionTitle = {
  margin: "0 0 14px",
  fontSize: 14,
  fontWeight: 800,
  color: "#24272d"
};

const equipmentGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
  gap: "14px 10px",
  marginBottom: 22
};

const equipmentField = {
  display: "flex",
  flexDirection: "column",
  gap: 7,
  minWidth: 0
};

const equipmentLabel = {
  fontSize: 14,
  fontWeight: 700,
  color: "#344054"
};

const equipmentInput = {
  width: "100%",
  minHeight: 26,
  border: "1px solid #cfd7e4",
  borderRadius: 10,
  padding: "10px 16px",
  fontSize: 16,
  color: "#111827",
  background: "#fff",
  boxSizing: "border-box"
};

const equipmentTextarea = {
  ...equipmentInput,
  minHeight: 68,
  resize: "vertical",
  marginBottom: 14
};

const equipmentModalFooter = {
  display: "flex",
  justifyContent: "flex-end",
  gap: 10,
  padding: "14px 20px",
  borderTop: "1px solid #e5e7eb"
};

const equipmentCancelBtn = {
  padding: "10px 18px",
  border: "1px solid #d7dde7",
  borderRadius: 10,
  background: "#fff",
  color: "#24272d",
  fontSize: 16,
  fontWeight: 600,
  cursor: "pointer"
};

const equipmentBookBtn = {
  padding: "10px 20px",
  border: "none",
  borderRadius: 10,
  background: "#0b5cff",
  color: "#fff",
  fontSize: 16,
  fontWeight: 700,
  cursor: "pointer"
};

const th = {
  border: "1px solid #ccc",
  padding: 10,
  textAlign: "left"
};
 
const td = {
  border: "1px solid #ccc",
  padding: 10
};
const input = {
          width: "100%",
          minHeight: 90,
          marginTop: 6,
          marginBottom: 12,
          padding: "10px 12px",
          borderRadius: 6,
          border: "1px solid #d1d5db",
          fontSize: 14,
          resize: "vertical"
};
const alertBtn = {
  marginTop: 10,
          padding: "10px 20px",
          borderRadius: 6,
          border: "1.5px solid #007bff",
          background: "#007bff",
          color: "#fff",
          fontWeight: 600,
          cursor: "pointer"
};
const doctorsReportBtn = {
  padding: "10px 20px", background: "#2563EB", color: "#fff",
  border: "none", borderRadius: 6, fontSize: 14,
  fontWeight: 600, cursor: "pointer", marginTop: 8
};
